export default "__VITE_ASSET__Dx6oS$tf__"